up.compiler('#sidebar', (element) => {
  const main = document.querySelector('main');

  if (main) {
    element.addEventListener('hide.bs.collapse', (event) => {
      if(event.target.classList.contains('sidebar-section')) {
        return;
      }

      main.classList.remove('col-sm-10');
      main.classList.add('col-sm-12');
    })
    element.addEventListener('show.bs.collapse', (event) => {
      if(event.target.classList.contains('sidebar-section')) {
        return;
      }

      main.classList.add('col-sm-10');
      main.classList.remove('col-sm-12');
    })
  }
})


up.compiler('.close-sidebar', (element) => {
  element.addEventListener('click', () => {
    const sidebar = document.querySelector('#sidebar');
    if(sidebar) {
      const collapseElement = bootstrap.Collapse.getInstance(sidebar);
      if(collapseElement) {
        collapseElement.hide();
      }
    }
    
    const main = document.querySelector('main');
    if (main) {
      main.classList.remove('col-sm-10');
      main.classList.add('col-sm-12');
    }
  })
})

up.compiler('.close-sidebar-offcanvas', (element) => {
  element.addEventListener('click', () => {
    const offcanvas = document.querySelector('#offcanvassidebar');
    if(offcanvas) {
      const collapseElement = bootstrap.Offcanvas.getInstance(offcanvas);
      if(collapseElement) {
        collapseElement.hide();
      }
    }
  })
})
